<!-- 模块-支付公共 -->
<template>
  <span></span>
</template>

<script>
export default {
  name: 'pay',
  data () {
    return {
      use_type: '',
      sp_num: '',
      post: {
        type: '',
        order_id: 0,
        user_code: ''
      },
      ver_num: 0,
      toast: null
    }
  },

  methods: {
    // 启动组件
    show (data) {
      this.use_type = '1' + data.type.toString()
      this.post.type = data.type
      this.post.order_id = data.order_id
      this.sel_sp()
    },

    // 查可用支付服务商编号
    sel_sp () {
      this.$root.loadingAll = true
      this.ax(this, 'sel_sp_wechat_set', {web_type: 'g', use_type: this.use_type}, (res) => {
        if (res.err_num === 0) {
          this.sp_num = res.data.sp_num
          this.post.user_code = res.data.openid
          this.call_pay()
        }
      })
    },

    // 调起支付
    call_pay () {
      let data = this.post
      data.use_type = this.use_type
      data.num = this.sp_num

      this.ax(this, 'call_pay', data, (res) => {
        if (res.err_num === 0) {
          // 订单状态异常
          if (res.data.status === 4) {
            this.$root.loadingAll = false
            this.$emit('result', {res: false, type: 1})
            return this.$notify({ type: 'warning', message: res.data.msg })
          }
          let pay = res.data.pay
          global.wx.chooseWXPay({
            timestamp: pay.timeStamp,
            nonceStr: pay.nonceStr,
            package: pay.package,
            signType: pay.signType,
            paySign: pay.paySign,
            success: () => {
              // 支付成功
              this.$root.loadingAll = false
              this.$emit('result', {res: true})
              this.$notify({ type: 'success', message: '支付成功' })
            },
            cancel: () => {
              // 用户取消
              this.undo_pay()
            },
            fail: () => {
              // 支付失败
              this.undo_pay()
            }
          })
        }
      })
    },

    // 撤销支付/并删除订单
    undo_pay (type) {
      this.ax(this, 'undo_pay', this.post, (res) => {
        if (res.err_num === 0) {
          // 消费订单清除会员
          if (this.post.type === 1) {
            this.ax(this, 'del_p_level', this.post, () => {
              this.err()
            })
          }

          // 充值同时删除订单
          if (this.post.type === 2) {
            this.post.order_data = this.post.order_id
            this.ax(this, 'del_order', this.post, () => {
              this.err()
            })
          }
        }
      })
    },

    // 支付失败
    err () {
      this.$emit('result', {res: false, type: 2})
      this.$root.loadingAll = false
      this.$notify({ type: 'warning', message: '支付失败' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pay.vue